import { render } from "./basic_tables.vue?vue&type=template&id=ab2ff2ea"
import script from "./basic_tables.vue?vue&type=script&lang=js"
export * from "./basic_tables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__